import { render, staticRenderFns } from "./WaitingForContract.vue?vue&type=template&id=419c0bfa&"
import script from "./WaitingForContract.vue?vue&type=script&lang=js&"
export * from "./WaitingForContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports